import * as React from 'react';
import { connect, Provider } from 'react-redux';
import store from '@state/store';
import { ScReact } from '@components-react/ScReact';
import { selectProduct, selectVariant } from '@components/ProductDetail/state/productDetailSlice';
import { ProvideProductDetailOnPageLoad } from '../ProductDetailOnPageLoad';
import type { ScProps } from '@components-react/ScProps';

export const ProductTitle = ({ product, variant }: { product: any; variant: any; }) => {
  const title: string = variant?.title ?? product?.title ?? '[Product Title]';
  const code: string = variant?.code ?? product?.code ?? '[Product Code]';

  return (
    <>
      <div className="component title">
        <div className="component-content">
          <h1 className="h1">{title}</h1>
        </div>
      </div>
      <div data-art-code className="text-gray-500"><span>Art: </span>{code}</div>
    </>
  );
};

const mapStateToProps = (state: any, ownProps?: any) => {
  const product = selectProduct(state) ?? ownProps.product;
  const variant = selectVariant(state) ?? ownProps.variant;

  return {
    product,
    variant
  };
};
export const ConnectedProductTitle = connect(mapStateToProps)(ProductTitle);


export const ProvideProductTitle = (props: ScProps<any>) => {
  const product = props.data?.product;
  const variant = props.data?.variant;
  return (
    <ScReact {...props}>
      <ProvideProductDetailOnPageLoad {...props} />
      <Provider store={store}>
        <ConnectedProductTitle product={product} variant={variant} />
      </Provider>
    </ScReact>
  );
};







